<div class="payment-row">
  <div class="label">
    {{ ('moneyAndTransactions.' + translateKey) | translate }}
  </div>
  <div class="value">
    {{ value }}
    @if(!hideClipboardCopy) {
      <svg-icon
        src="assets/icons/clipboard.svg"
        class="edit-icon"
        (click)="copyToClipboard()"
        nz-tooltip
        autoCloseOnScroll
        [nzTooltipTitle]="tooltip"
        [nzTooltipVisible]="tooltipVisible()"
        [nzTooltipTrigger]="null"
        nzTooltipOverlayClassName="lean flex-center"
        nzTooltipPlacement="right"
      ></svg-icon>
      <ng-template #tooltip>
        <liberro-tooltip-content>
            <div tooltipContent>
                <span>{{ 'moneyAndTransactions.copiedToClipboard' | translate }}</span>
            </div>
        </liberro-tooltip-content>
      </ng-template>
    }
  </div>
</div>
